import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RequestOptions } from '../types/common';
import type {
  RawMpptResponse,
  RawPvCapabilities,
  RawPvHistoryRequest,
  RawPvStringResponse,
} from '../types/pv';

/**
 * PvController pvhistory/* 호출 함수. 셋 다 같은 요청(RawPvHistoryRequest).
 * 반환값은 BaseResponse 언랩 후 payload.
 */
export function createPvApi(http: Http) {
  return {
    /** POST /pvhistory/capabilities — 조회 가능 항목 */
    async capabilities(
      body: RawPvHistoryRequest,
      options?: RequestOptions,
    ): Promise<RawPvCapabilities> {
      const res = await http.post<RawPvCapabilities>(endpoints.pv.capabilities, body, {
        signal: options?.signal,
      });
      return res.data;
    },

    /** POST /pvhistory/strings — string 단위 이력 */
    async strings(
      body: RawPvHistoryRequest,
      options?: RequestOptions,
    ): Promise<RawPvStringResponse> {
      const res = await http.post<RawPvStringResponse>(endpoints.pv.strings, body, {
        signal: options?.signal,
      });
      return res.data;
    },

    /** POST /pvhistory/mppts — MPPT 단위 이력 */
    async mppts(body: RawPvHistoryRequest, options?: RequestOptions): Promise<RawMpptResponse> {
      const res = await http.post<RawMpptResponse>(endpoints.pv.mppts, body, {
        signal: options?.signal,
      });
      return res.data;
    },
  };
}
